
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.02 18"}, attrs),
              ...rest,
            },
            children.concat([_c('ellipse',{attrs:{"cx":"9.01","cy":"9","rx":"9.01","ry":"9"}})])
          )
        }
      }
    